import type { TermsPolicy } from '@/types';

interface PolicyContentProps {
  termsPolicy: TermsPolicy | null;
  className?: string;
}

export function PolicyContent({ termsPolicy, className = '' }: PolicyContentProps) {
  
  if (!termsPolicy) {
    return (
      <div className={`space-y-4 ${className}`}>
        {/* 로딩 스켈레톤 */}
        <div className="animate-pulse space-y-4">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-4/5"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`${className}`}>
      <div className="bg-white border border-gray-200 rounded-lg p-8 max-w-4xl mx-auto">
        {/* 약관 내용 */}
        <div 
          className="prose prose-gray max-w-none whitespace-pre-wrap
            prose-headings:text-[#222222] prose-headings:font-semibold
            prose-h1:text-[24px] prose-h1:mb-6 prose-h1:mt-8
            prose-h2:text-[20px] prose-h2:mb-4 prose-h2:mt-6  
            prose-h3:text-[18px] prose-h3:mb-3 prose-h3:mt-4
            prose-p:text-[15px] prose-p:leading-relaxed prose-p:mb-4 prose-p:text-gray-700
            prose-ul:text-[15px] prose-ul:text-gray-700
            prose-ol:text-[15px] prose-ol:text-gray-700
            prose-li:mb-2
            prose-strong:text-[#222222] prose-strong:font-semibold
            prose-a:text-[#51C854] prose-a:no-underline hover:prose-a:underline
          "
          dangerouslySetInnerHTML={{ __html: termsPolicy.content }}
        />

        {/* 구분선 및 추가 정보 */}
        {(termsPolicy.version || termsPolicy.created_at) && (
          <div className="mt-12 pt-6 border-t border-gray-200">
            <div className="text-center space-y-2">
              {termsPolicy.version && (
                <p className="text-[13px] text-gray-500">
                  문서 버전: {termsPolicy.version}
                </p>
              )}
              {termsPolicy.created_at && (
                <p className="text-[13px] text-gray-500">
                  생성일자: {new Date(termsPolicy.created_at).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}